/*
    Description: The placeholder route
*/
import { MetaFunction } from '@remix-run/react';
import { motion } from 'framer-motion';

import { Layout } from '~/components/layout';
import bannerImg from '~/images/banner.png';

export const meta: MetaFunction = () => {
    return [
        { title: 'Coming Soon' },
        {
            content:
                'The ultimate AI-powered job search solution - coming soon!',
            name: 'description',
        },
    ];
};

const ComingSoon = () => {
    return (
        <Layout isLive={false} user={null}>
            <div
                className="hero mb-8 max-h-[20%] w-full"
                style={{
                    backgroundImage: `url(${bannerImg})`,
                }}
            >
                {/* eslint-disable-next-line tailwindcss/migration-from-tailwind-2 */}
                <div className="hero-overlay bg-opacity-60"></div>
                <div className="hero-content text-center text-neutral-content">
                    <div className="max-w-md">
                        <motion.div
                            animate={{ opacity: 100, y: 0 }}
                            className="py-8 text-center"
                            initial={{ opacity: 0, y: 50 }}
                            transition={{ duration: 1 }}
                        >
                            <p className="cursor-default pb-8 text-6xl font-bold md:text-8xl">
                                Coming Soon
                            </p>
                        </motion.div>
                    </div>
                </div>
            </div>

            <motion.div
                animate={{ opacity: 100, y: 0 }}
                initial={{ opacity: 0, y: 50 }}
                transition={{ delay: 0.35, duration: 1 }}
            >
                <motion.p className="text-center text-4xl">
                    The ultimate solution to{' '}
                    <span className="text-gradient pb-4">supercharge</span> your
                    job search!
                </motion.p>
                <p className="text-center italic">
                    Not seeing some words? Try turning off Dark Reader! We are
                    working on a fix which will be out as soon as possible.
                </p>
            </motion.div>
            <motion.div
                animate={{ opacity: 100, y: 0 }}
                initial={{ opacity: 0, y: 50 }}
                transition={{ delay: 0.65, duration: 1 }}
            >
                <div className="divider my-8" />
            </motion.div>
            <motion.div
                animate={{ opacity: 100, y: 0 }}
                initial={{ opacity: 0, y: 50 }}
                transition={{ delay: 0.8, duration: 1 }}
            >
                <div className="flex items-center justify-center">
                    <div className="card flex w-full content-center bg-base-300 md:w-3/4">
                        <div className="card-body rounded-lg">
                            <p className="text-2xl">
                                By choosing ResumeSupercharged, you will get
                                unlimited access to:
                            </p>
                            <ul className="list-inside list-disc pl-4 pt-2">
                                <li className="list-item text-xl">
                                    <span className="text-gradient">
                                        World-class
                                    </span>{' '}
                                    AI-powered resume generation (customized to
                                    your exact skillsets, experience and
                                    education)
                                </li>
                                <li className="list-item text-xl">
                                    Our powerful{' '}
                                    <span className="text-gradient">
                                        cover-letter generation suite
                                    </span>
                                </li>
                                <li className="list-item text-xl">
                                    An editable preview so you can tweak each
                                    bit of text
                                </li>
                            </ul>
                            <p className="mt-8 text-2xl">
                                You will always be able to{' '}
                                <span className="text-gradient">
                                    cancel anytime
                                </span>{' '}
                                and will{' '}
                                <span className="text-gradient">
                                    retain access
                                </span>{' '}
                                to any resumes or cover letters that you
                                generated with us, even if you cancel!
                            </p>

                            <p className="mt-8 text-2xl">
                                If this sounds interesting to you, please{' '}
                                <span className="text-gradient">bookmark</span>{' '}
                                this page and check back later! We are aiming to
                                launch in mid Fall of 2024!
                            </p>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Layout>
    );
};

export default ComingSoon;
